<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div style="width: 100%;">
    <table class="table table-tenant" :class="{'vat': vatRegistered}">
        <tr class="row">
            <th class="cell cell-charge">
                Tenant Charges:
            </th>
            <th class="cell cell-amount">
                Amount
            </th>
            <th v-if="vatRegistered" class="cell cell-vat">
                Vat (20%)
            </th>
            <th v-if="vatRegistered" class="cell cell-total">
                Total (inc VAT)
            </th>
			<th class="cell cell-delete"></th>
        </tr>
        <tr class="row" v-for="(item, index) in charges">
            <td class="cell cell-charge">
                <input class="mdc-textfield__input" type="text" :placeholder='"Charge Title"' v-model="item.title">
            </td>
            <td class="cell cell-amount">
                <input class="mdc-textfield__input" type="number" :placeholder='"Amount of " + item.title' v-model="item.amount">
            </td>
            <td v-if="vatRegistered" class="cell cell-vat">
                <span>{{item.vat = parseFloat(item.amount * 0.20).toFixed(2)}}</span>
            </td>
            <td v-if="vatRegistered" class="cell cell-total">
                <span name="tenancy_total">{{item.final_price = parseFloat(item.amount * 0.20 + +item.amount).toFixed(2)}}</span>
            </td>
			<td class="cell cell-delete">
				<a href="#" @click.prevent="remove(index)"><i class="ico ico-trash"></i></a>
			</td>
        </tr>
    </table>
	<a href="#" @click.prevent="add_charge">Click here to add another charge</a>
	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->

<script>
	export default {
        props: {
          value: Array,
          vatRegistered: Boolean
        },
        data: function(){
            return{
                charges: this.value,
            }
        },
        created: function() {
          if(this.charges.length == 0){
              this.charges = [
                  {
                    title: 'Tenancy Set Up',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  },
                  {
                    title: 'Additional person',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  },
                  {
                    title: 'Guarantor',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  },
                  {
                    title: 'Permitted occupier',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  },
                  {
                    title: 'Amendment fee',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  },
                  {
                    title: 'Renewal fee',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  },
                  {
                    title: 'Check out fee',
                    amount: 0,
                    vat: 0,
                    final_price: 0
                  }
              ]
          }
        },
        computed: {
            // total() {
            //     const total = this.charges.reduce(function(acc, charge) {
            //         const currentTotal = charge.amount * 0.20 + +charge.amount;
            //         return parseFloat(acc + currentTotal);
            //     }, 0);
            //     return total.toFixed(2);
            // }
        },
        watch: {
            charges:{
                handler: function(charges){
                    this.$emit('input', charges);
                },
                deep: true
            }
        },
        methods: {
            add_charge: function(){
                this.charges.push({
                    title: '',
                    amount: 0,
                    vat: 0,
                    amount_with_vat: 0
                })
            },
            remove: function(index) {
                this.charges.splice(index, 1);
		    },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/TenantFee.vue